export default () => [
  {
    fixed: 'left',
    field: 'sortOrder',
    align: 'center',
    width: 50,
    title: '#',
    sortable: true,
    sortType: 'number',
  },
  {
    fixed: 'left',
    width: 40,
    align: 'center',
    field: 'left',
    type: 'checkbox',
  },
  {
    fixed: 'left',
    field: 'col-opt',
    title: '操作',
    headerAlign: 'center',
    align: 'center',
    width: 90,
    slots: {
      default: 'opt',
    },
  },
  {
    field: 'linePointName',
    align: 'left',
    width: 140,
    title: '节点名称',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
    sortType: 'string',
  },
  {
    align: 'left',
    width: 100,
    title: '类型',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
    sortType: 'string',
    slots: {
      default: 'type',
    },
  },
  {
    field: 'provinceName',
    align: 'left',
    width: 130,
    title: '省份',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
    sortType: 'string',
  },
  {
    field: 'cityName',
    align: 'left',
    width: 130,
    title: '城市',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
    sortType: 'string',
  },
  {
    field: 'districtName',
    align: 'left',
    width: 130,
    title: '区县',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
    sortType: 'string',
  },
  {
    field: 'linePointAddress',
    align: 'left',
    minWidth: 170,
    title: '详细地址',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
    sortType: 'string',
  },
  //   {
  //     field: 'distance',
  //     align: 'left',
  //     width: 100,
  //     title: '节点距离',
  //     showHeaderOverflow: 'title',
  //     showOverflow: 'ellipsis',
  //     sortable: true,
  //   },
  //   {
  //     align: 'center',
  //     width: 100,
  //     title: '有效状态',
  //     slots: {
  //       default: 'status',
  //     },
  //   },
]
